
    <section role="main">
      <ng-content select="pmv-main-content-header"></ng-content>
      <ng-content select="pmv-main-content-body"></ng-content>
    </section>
  


// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵb.html